/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Vs_Yaml_Xml_Faq_A4Inputs */

const en_guide_json_vs_yaml_xml_faq_a4 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YAML is a superset of JSON, so any valid JSON is also valid YAML. YAML adds features like comments and anchors that JSON does not have, which is part of why config files often prefer it.`)
};

const ko_guide_json_vs_yaml_xml_faq_a4 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YAML은 JSON의 상위 집합이라, 유효한 JSON은 모두 유효한 YAML이기도 합니다. YAML은 주석과 앵커처럼 JSON에 없는 기능을 더하는데, 설정 파일이 YAML을 자주 선호하는 이유이기도 합니다.`)
};

const ja_guide_json_vs_yaml_xml_faq_a4 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YAML は JSON の上位集合なので、有効な JSON はすべて有効な YAML でもあります。YAML はコメントやアンカーなど JSON にない機能を加えており、設定ファイルが YAML を好むことが多い理由の一つです。`)
};

/**
* | output |
* | --- |
* | "YAML is a superset of JSON, so any valid JSON is also valid YAML. YAML adds features like comments and anchors that JSON does not have, which is part of why ..." |
*
* @param {Guide_Json_Vs_Yaml_Xml_Faq_A4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_vs_yaml_xml_faq_a4 = /** @type {((inputs?: Guide_Json_Vs_Yaml_Xml_Faq_A4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Vs_Yaml_Xml_Faq_A4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_vs_yaml_xml_faq_a4(inputs)
	if (locale === "ko") return ko_guide_json_vs_yaml_xml_faq_a4(inputs)
	return ja_guide_json_vs_yaml_xml_faq_a4(inputs)
});